import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from './components/nuxt-error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_workbox_923f461a from 'nuxt_plugin_workbox_923f461a' // Source: ./workbox.js (mode: 'client')
import nuxt_plugin_nuxticons_5daf9e11 from 'nuxt_plugin_nuxticons_5daf9e11' // Source: ./nuxt-icons.js (mode: 'all')
import nuxt_plugin_vuesocialsharingplugin_1dbd09e0 from 'nuxt_plugin_vuesocialsharingplugin_1dbd09e0' // Source: ./vue-social-sharing-plugin.js (mode: 'all')
import nuxt_plugin_clipboard_52ea3177 from 'nuxt_plugin_clipboard_52ea3177' // Source: ./clipboard.js (mode: 'client')
import nuxt_plugin_libplugin39d73df8_492b1402 from 'nuxt_plugin_libplugin39d73df8_492b1402' // Source: ./lib.plugin.39d73df8.js (mode: 'all')
import nuxt_plugin_plugin_c926c7c8 from 'nuxt_plugin_plugin_c926c7c8' // Source: ./matomo/plugin.js (mode: 'client')
import nuxt_plugin_templatesplugin6b7d10a6_63c1f97a from 'nuxt_plugin_templatesplugin6b7d10a6_63c1f97a' // Source: ./templates.plugin.6b7d10a6.js (mode: 'all')
import nuxt_plugin_pluginseo_3e92fc50 from 'nuxt_plugin_pluginseo_3e92fc50' // Source: ./nuxt-i18n/plugin.seo.js (mode: 'all')
import nuxt_plugin_pluginrouting_764439cf from 'nuxt_plugin_pluginrouting_764439cf' // Source: ./nuxt-i18n/plugin.routing.js (mode: 'all')
import nuxt_plugin_pluginmain_1caec800 from 'nuxt_plugin_pluginmain_1caec800' // Source: ./nuxt-i18n/plugin.main.js (mode: 'all')
import nuxt_plugin_veevalidate_0d22a658 from 'nuxt_plugin_veevalidate_0d22a658' // Source: ./vee-validate.js (mode: 'all')
import nuxt_plugin_nuxtvuemultiselect_aab30c06 from 'nuxt_plugin_nuxtvuemultiselect_aab30c06' // Source: ./nuxt-vue-multiselect.js (mode: 'all')
import nuxt_plugin_toast_ca138374 from 'nuxt_plugin_toast_ca138374' // Source: ./toast.js (mode: 'client')
import nuxt_plugin_axios_62741cd2 from 'nuxt_plugin_axios_62741cd2' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_moment_18a3d2e1 from 'nuxt_plugin_moment_18a3d2e1' // Source: ./moment.js (mode: 'all')
import nuxt_plugin_axios_5659d192 from 'nuxt_plugin_axios_5659d192' // Source: ../../plugins/axios.js (mode: 'all')
import nuxt_plugin_i18n_1fba523a from 'nuxt_plugin_i18n_1fba523a' // Source: ../../plugins/i18n.js (mode: 'all')
import nuxt_plugin_momentduration_10c6918c from 'nuxt_plugin_momentduration_10c6918c' // Source: ../../plugins/moment-duration.js (mode: 'all')
import nuxt_plugin_dashboardpro_0ff3e60e from 'nuxt_plugin_dashboardpro_0ff3e60e' // Source: ../../plugins/dashboard-pro.js (mode: 'all')
import nuxt_plugin_nuxtquillplugin_3ab6ceae from 'nuxt_plugin_nuxtquillplugin_3ab6ceae' // Source: ../../plugins/nuxt-quill-plugin.js (mode: 'client')
import nuxt_plugin_vuehighcharts_32bb4b22 from 'nuxt_plugin_vuehighcharts_32bb4b22' // Source: ../../plugins/vue-highcharts.js (mode: 'client')
import nuxt_plugin_plugin_d63d9cda from 'nuxt_plugin_plugin_d63d9cda' // Source: ./auth/plugin.js (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","beforeEnter":function(el) {
      console.log('Before enter...');
    },"appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule
const baseStoreOptions = { preserveState: process.client }

function registerModule (path, rawModule, options = {}) {
  return originalRegisterModule.call(this, path, rawModule, { ...baseStoreOptions, ...options })
}

async function createApp(ssrContext, config = {}) {
  const router = await createRouter(ssrContext)

  const store = createStore(ssrContext)
  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"Goyoga Manager","meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"hid":"description","name":"description","content":"The perfect application for the professionals of the better being"},{"hid":"mobile-web-app-capable","name":"mobile-web-app-capable","content":"yes"},{"hid":"apple-mobile-web-app-title","name":"apple-mobile-web-app-title","content":"goyoga-manager-v2"},{"hid":"author","name":"author","content":"Christophe Bourgois"},{"hid":"og:type","name":"og:type","property":"og:type","content":"website"},{"hid":"og:title","name":"og:title","property":"og:title","content":"goyoga-manager-v2"},{"hid":"og:site_name","name":"og:site_name","property":"og:site_name","content":"goyoga-manager-v2"},{"hid":"og:description","name":"og:description","property":"og:description","content":"The perfect application for the professionals of the better being"}],"link":[{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Fadmin\u002Ffavicon.ico"},{"rel":"manifest","href":"\u002Fadmin\u002F_nuxt\u002Fmanifest.834f9a50.json"},{"rel":"shortcut icon","href":"\u002Fadmin\u002F_nuxt\u002Ficons\u002Ficon_64.5f6a36.png"},{"rel":"apple-touch-icon","href":"\u002Fadmin\u002F_nuxt\u002Ficons\u002Ficon_512.5f6a36.png","sizes":"512x512"}],"style":[],"script":[{"src":"https:\u002F\u002Fpiwik.l-wa.fr\u002Fpiwik.js","body":true,"defer":true,"async":true}],"htmlAttrs":{"lang":"en"}},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (process.client && typeof nuxt_plugin_workbox_923f461a === 'function') {
    await nuxt_plugin_workbox_923f461a(app.context, inject)
  }

  if (typeof nuxt_plugin_nuxticons_5daf9e11 === 'function') {
    await nuxt_plugin_nuxticons_5daf9e11(app.context, inject)
  }

  if (typeof nuxt_plugin_vuesocialsharingplugin_1dbd09e0 === 'function') {
    await nuxt_plugin_vuesocialsharingplugin_1dbd09e0(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_clipboard_52ea3177 === 'function') {
    await nuxt_plugin_clipboard_52ea3177(app.context, inject)
  }

  if (typeof nuxt_plugin_libplugin39d73df8_492b1402 === 'function') {
    await nuxt_plugin_libplugin39d73df8_492b1402(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_plugin_c926c7c8 === 'function') {
    await nuxt_plugin_plugin_c926c7c8(app.context, inject)
  }

  if (typeof nuxt_plugin_templatesplugin6b7d10a6_63c1f97a === 'function') {
    await nuxt_plugin_templatesplugin6b7d10a6_63c1f97a(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginseo_3e92fc50 === 'function') {
    await nuxt_plugin_pluginseo_3e92fc50(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginrouting_764439cf === 'function') {
    await nuxt_plugin_pluginrouting_764439cf(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginmain_1caec800 === 'function') {
    await nuxt_plugin_pluginmain_1caec800(app.context, inject)
  }

  if (typeof nuxt_plugin_veevalidate_0d22a658 === 'function') {
    await nuxt_plugin_veevalidate_0d22a658(app.context, inject)
  }

  if (typeof nuxt_plugin_nuxtvuemultiselect_aab30c06 === 'function') {
    await nuxt_plugin_nuxtvuemultiselect_aab30c06(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_toast_ca138374 === 'function') {
    await nuxt_plugin_toast_ca138374(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_62741cd2 === 'function') {
    await nuxt_plugin_axios_62741cd2(app.context, inject)
  }

  if (typeof nuxt_plugin_moment_18a3d2e1 === 'function') {
    await nuxt_plugin_moment_18a3d2e1(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_5659d192 === 'function') {
    await nuxt_plugin_axios_5659d192(app.context, inject)
  }

  if (typeof nuxt_plugin_i18n_1fba523a === 'function') {
    await nuxt_plugin_i18n_1fba523a(app.context, inject)
  }

  if (typeof nuxt_plugin_momentduration_10c6918c === 'function') {
    await nuxt_plugin_momentduration_10c6918c(app.context, inject)
  }

  if (typeof nuxt_plugin_dashboardpro_0ff3e60e === 'function') {
    await nuxt_plugin_dashboardpro_0ff3e60e(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_nuxtquillplugin_3ab6ceae === 'function') {
    await nuxt_plugin_nuxtquillplugin_3ab6ceae(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuehighcharts_32bb4b22 === 'function') {
    await nuxt_plugin_vuehighcharts_32bb4b22(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin_d63d9cda === 'function') {
    await nuxt_plugin_plugin_d63d9cda(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // If server-side, wait for async component to be resolved first
  if (process.server && ssrContext && ssrContext.url) {
    await new Promise((resolve, reject) => {
      router.push(ssrContext.url, resolve, (err) => {
        // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
        if (!err._isRouter) return reject(err)
        if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

        // navigated to a different route in router guard
        const unregister = router.afterEach(async (to, from) => {
          ssrContext.url = to.fullPath
          app.context.route = await getRouteData(to)
          app.context.params = to.params || {}
          app.context.query = to.query || {}
          unregister()
          resolve()
        })
      })
    })
  }

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
